module.exports = __webpack_public_path__ + "static/media/installing-nodejs-on-your-device.368cc11c.md";